SC.series_purchases = (() => {
  let container, pauseModal, closeBtn, hiddenInput, displayBox, formattedSpan, pauseBtn, firstEl, lastEl;
  let focusableEls = [];
  const init = () => {
    container = document.getElementById('purchases-history-list');
    pauseModal = document.getElementById('membership-modal');
    closeBtn = document.querySelector('.membership-modal__close');
    hiddenInput = document.querySelector('.membership-modal__hidden-date-input');
    displayBox = document.getElementById('datepicker-display');
    formattedSpan = document.getElementById('formatted-date');
    pauseBtn = document.getElementById('pause-membership-btn');
     // Make display box focusable
    if (displayBox) {
      displayBox.setAttribute('tabindex', '0');
      displayBox.setAttribute('role', 'button');
      displayBox.setAttribute('aria-describedby', 'formatted-date');
    }
    setModalEvents();
    document.removeEventListener('keydown', handleGlobalEsc);
    document.addEventListener('keydown', handleGlobalEsc);
  };

  // Global Esc key handler
  const handleGlobalEsc = (e) => {
    if (e.key === 'Escape') {
      const confirmModal = document.querySelector('.membership-confirmation-modal');
      if (confirmModal && confirmModal.style.visibility === 'visible') {
        closeConfirmationModal(confirmModal);
      } else if (pauseModal.style.display === 'flex') {
        closeModal();
      }
    }
  };

  // Helper to close confirmation modal
  const closeConfirmationModal = (confirmModal, handleCancel, handleConfirm, handleKeyPress, handleOutsideClick) => {
    confirmModal.style.visibility = 'hidden';
    confirmModal.style.opacity = 0;
    // Remove event listeners
    const btnCancel = confirmModal.querySelector('.button-cancel');
    const btnRight = confirmModal.querySelector('.button-right');
    if (handleCancel) btnCancel.removeEventListener('click', handleCancel);
    if (handleConfirm) btnRight.removeEventListener('click', handleConfirm);
    if (handleKeyPress) confirmModal.removeEventListener('keydown', handleKeyPress);
    if (handleOutsideClick) window.removeEventListener('click', handleOutsideClick);
  };

  // Attach event listeners
  const setModalEvents = () => {
    if (!container || !pauseModal) return;

    const openPauseModal = () => {
      const selRegion = document.getElementById('downshift-0-label').textContent;
      pauseModal.querySelector('.membership-modal__studio').textContent = selRegion;
      // Show membership pause modal
      pauseModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
      updateFocusable();
      if (firstEl) firstEl.focus();

      document.addEventListener('keydown', handleGlobalEsc);
    };

    const showMembershipConfirmation = (action, membershipPauseId, membershipDate, nextPauseDate) => {
      if (action === 'reactivate') {
        showConfirmationModal(
          'Are you sure you want to reactivate paused membership?',
          `It is currently paused until ${membershipDate}. Once you reactivate this membership you won’t be able to pause it until ${nextPauseDate}`,
          'Reactivate',
          () => updateMembership('reactivate', { pause_id: membershipPauseId })
        );
      } else if (action === 'cancel') {
        showConfirmationModal(
          'Are you sure you want to cancel scheduled membership pause?',
          `It is scheduled to pause on ${membershipDate}.\nOnce cancelled, this membership will stay active.`,
          'Cancel Pause',
          () => updateMembership('cancel', { pause_id: membershipPauseId })
        );
      }
    };

    const formatDateToLong = (dateStr) => {
      if (!dateStr || typeof dateStr !== 'string') return '';
      const date = new Date(`${dateStr}T00:00:00`);
      if (isNaN(date)) return '';
      // Passing "undefined" as the first argument to toLocaleDateString will use the browser's default locale.
      return date.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    };


    // When clicking on button inside purchase history → open modal

    container.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn || !btn.dataset.payload) return;

      const payload = JSON.parse(btn.dataset.payload);

      /* SCHEDULED: membership pause start date
        ACTIVE: membership pause end date */
      const action = payload.type;

      if (action === 'pause') {
        e.preventDefault();
        openPauseModal();
      } else {
        const membershipDate = formatDateToLong(payload.date);
        const membershipPauseId = payload.id;

        if (action === 'reactivate') {
          const nextPauseDate = formatDateToLong(payload.next_membership_pause_date);
          showMembershipConfirmation(action, membershipPauseId, membershipDate, nextPauseDate);
        } else {
          showMembershipConfirmation(action, membershipPauseId, membershipDate);
        }
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    window.addEventListener('click', (e) => {
      if (e.target === pauseModal) closeModal();
    });
    // Keyboard navigation inside modal
    pauseModal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
      trapFocus(e);
    });

    const trapFocus = (e) => {
      if (e.key !== 'Tab') return;
      updateFocusable();
      if (focusableEls.length === 0) return;

      if (e.shiftKey) {
        // Shift + Tab (backward)
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
         // Tab (forward)
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    };

    // Calendar date handling
    if (displayBox && hiddenInput) {
      displayBox.addEventListener('click', () => hiddenInput.showPicker());
      displayBox.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          hiddenInput.showPicker();
        }
      });

      // When user picks a date, format and display it
      hiddenInput.addEventListener('change', () => {
        formattedSpan.textContent = formatDateToLong(hiddenInput.value);
      });
    }

    // Pause/reactivate button click
    if (pauseBtn) {
      pauseBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (pauseBtn.dataset.action === 'pause') {
          pauseMembership();
        }
      });
    }

    const updateFocusable = () => {
      focusableEls = Array.from(pauseModal.querySelectorAll('button, [tabindex]:not([tabindex="-1"]), input'))
        .filter((el) => !el.disabled && el.offsetParent !== null);
      firstEl = focusableEls[0];
      lastEl = focusableEls[focusableEls.length - 1];
    };
  };

  // method for Membership Pause/Cancel/Reactivate
  const updateMembership = (action, data = {}) => {
    const actionPath = data?.pause_id ? `${data.pause_id}/${action}` : action;

    fetch(`/profile/membership/${actionPath}/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then((response) => {
        updateBtn(action, response.response);
        confirmation(null, response.message);
        closeModal();
        setTimeout(() => window.location.reload(), 2500);
      })
      .catch((error) => {
        let msg = error.message || 'Unknown error';
        try {
          msg = JSON.parse(error.responseText)?.message || msg;
        } catch (e) {
          console.error(e);
        }
        confirmation(null, msg);
        closeModal();
      });
  };

  const pauseMembership = () => {
    if (!hiddenInput.value) {
      confirmation(null, `Please select a date before pausing membership`);
      return;
    }
    updateMembership('pause', { pause_date: hiddenInput.value });
  };

  // Update class name & text for action button on list
  const updateBtn = (action, apiResponse) => {
    const btn = document.querySelector('.profile-purchase-history__button');
    let nextAction = 'reactivate';
    let nextDate = '';
    let label = 'Reactivate';
    let payload = {};

    // when membership paused with future date
    if (apiResponse['status'] === 'scheduled') {
      nextAction = 'cancel';
      label = 'Cancel Pause';
      nextDate = apiResponse.start_date;
      payload = { type: nextAction, date: nextDate, id: apiResponse.id };
    } else if (['resumed', 'cancelled'].includes(apiResponse['status'])) {
      nextAction = 'pause';
      label = 'Pause';
      payload = { type: nextAction };
    }

    btn.classList.replace(
      `profile-purchase-history__button--${action}`,
      `profile-purchase-history__button--${nextAction}`
    );

    btn.classList.add('is-disabled');
    btn.textContent = label;
    btn.dataset.payload = JSON.stringify(payload);
  };

  // Close membership pause modal and restore scroll
  const closeModal = () => {
    pauseModal.style.display = 'none';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
    document.removeEventListener('keydown', handleGlobalEsc);
  };

  const showConfirmationModal = (titleText, messageText, rightButtonText, onConfirm) => {
    const confirmModal = document.querySelector('.membership-confirmation-modal');
    const title = confirmModal.querySelector('.title');
    const message = confirmModal.querySelector('.message');
    const btnCancel = confirmModal.querySelector('.button-cancel');
    const btnRight = confirmModal.querySelector('.button-right');

    title.textContent = titleText;
    message.textContent = messageText;
    message.style.whiteSpace = 'pre-line';
    btnRight.textContent = rightButtonText;

    // Update ARIA labels for buttons
    btnCancel.setAttribute('aria-label', `Cancel ${titleText}`);
    btnRight.setAttribute('aria-label', `${rightButtonText} action`);

    confirmModal.style.visibility = 'visible';
    confirmModal.style.opacity = 1;

    const closeModalHandler = () => {
      closeConfirmationModal(confirmModal, handleCancel, handleConfirm, handleKeyPress, handleOutsideClick);
    };

    const handleCancel = () => closeModalHandler();
    const handleConfirm = () => {
      closeModalHandler();
      if (onConfirm) onConfirm();
    };

    const handleOutsideClick = (e) => {
      if (e.target === confirmModal) closeModalHandler();
    };

    const handleKeyPress = (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        if (document.activeElement === btnCancel) btnRight.focus();
        else btnCancel.focus();
      } else if (e.key === 'Escape') {
        closeModalHandler();
      }
    };

    const handleButtonKeyPress = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (e.target === btnCancel) handleCancel();
        else if (e.target === btnRight) handleConfirm();
      }
    };

    // Add event listeners
    btnCancel.addEventListener('click', handleCancel);
    btnRight.addEventListener('click', handleConfirm);
    btnCancel.addEventListener('keydown', handleButtonKeyPress);
    btnRight.addEventListener('keydown', handleButtonKeyPress);
    confirmModal.addEventListener('keydown', handleKeyPress);
    window.addEventListener('click', handleOutsideClick);

    btnCancel.focus();
  };

  init();

  return { init };
})();
